import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Box, Grid, TextField, Typography } from "@mui/material";
import type {
  MetaTemplateVariable,
  NotificationTestFormValues,
} from "../../types/notificationTest";

type VariablesField = "variables" | "headerTextVariables";

interface Props {
  variables: MetaTemplateVariable[];
  field?: VariablesField;
  title?: string;
}

export const MetaTemplateVariablesFields: React.FC<Props> = ({
  variables,
  field = "variables",
  title = "Template variables",
}) => {
  const { control } = useFormContext<NotificationTestFormValues>();

  if (variables.length === 0) return null;

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "primary.light",
        borderRadius: 1,
        p: 2,
        mb: 2,
      }}
    >
      <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
        {title}
      </Typography>
      <Grid container spacing={{ xs: 1.5, sm: 2 }}>
        {variables.map((v, i) => {
          const label = /^\d+$/.test(v.paramName)
            ? `{{${v.paramName}}}`
            : v.paramName;
          return (
            <Grid item xs={12} md={6} key={`${v.paramName}-${i}`}>
              <Controller
                name={`message.${field}.${i}.value` as const}
                control={control}
                render={({ field: rhfField }) => (
                  <TextField
                    {...rhfField}
                    fullWidth
                    label={label}
                    placeholder={v.example ?? ""}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default MetaTemplateVariablesFields;
